import styled from '@emotion/styled';

import { maxWidthAndCenter } from '@styles';

const BreakoutContainer = styled.div`
  background: var(--orange);

  .breakout__content {
    ${maxWidthAndCenter}
    z-index: 1;
    border-radius: 4rem;
    margin-top: -6rem;
    padding: 2rem 2rem 3rem 2rem;
    background: white;
    position: relative;
  }

  h2 {
    padding: 0 0 2rem;
    font-size: 2.25rem;
    font-weight: 900;
    color: var(--orange);
    text-align: center;
    text-transform: uppercase;
  }

  .breakout__items {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .breakout__items__item {
    width: 100%;
    max-width: 18.5%;
    text-align: center;

    img {
      padding: 0 0 0.75rem;
    }

    h1,
    h2,
    h3 {
      padding: 0 0 0.25rem;
      font-size: 1.1rem;
      color: var(--orange);
      text-transform: uppercase;
      font-weight: 900;
      line-height: 1.2;
    }

    p,
    span {
      color: var(--orange);
      font-weight: 500;
      line-height: 1.5;
      font-size: 0.9rem;
    }
  }

  .breakout__spacer {
    height: 0;
  }

  @media screen and (max-width: 1470px) {
    .breakout__content {
      width: calc(100% - 4rem);
      margin: -6rem 2rem 0;
    }
  }

  @media screen and (max-width: 1152px) {
    h2 {
      display: none;
      visibility: hidden;
    }

    .breakout__content {
      border-radius: 0;
      margin: 0px;
      padding: 2rem;
      width: 100%;
    }

    .breakout__items {
      flex-wrap: wrap;
      justify-content: center;
    }

    .breakout__items__item {
      max-width: 50%;
      margin: 0 0 1.5rem;
      flex-shrink: 0;

      p {
        display: none;
        visibility: hidden;
      }
    }
  }
`;

export { BreakoutContainer };
